import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-all-opened-tickets',
  templateUrl: './all-opened-tickets.component.html',
  styleUrls: ['./all-opened-tickets.component.css']
})
export class AllOpenedTicketsComponent implements OnInit {
  u:any={};

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    //this.TotalOpenTickets();
  }

  TotalOpenTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.totalOpenTickets(this.u.FromDate,this.u.ToDate)
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

Print = function () {
  window.print()
}

}



// WEBPACK FOOTER //
// ./src/app/reports/all-opened-tickets/all-opened-tickets.component.ts